module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-15.04ff8e4b.png";